(() => {
  const init = () => {
    document.querySelectorAll('[data-bbb-product-requirements]').forEach((panel) => {
      if (panel.dataset.bbbValidationReady === 'true') return;
      panel.dataset.bbbValidationReady = 'true';
      const form = panel.closest('form');
      if (!form) return;

      form.addEventListener('submit', (event) => {
        const requiredFields = panel.querySelectorAll('input[required], textarea[required]');
        for (const field of requiredFields) {
          if (!field.value.trim()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            field.setCustomValidity('Fyll i detta fält innan du lägger produkten i varukorgen.');
            field.reportValidity();
            field.focus();
            return;
          }
          field.setCustomValidity('');
        }
      }, true);

      panel.querySelectorAll('input[required], textarea[required]').forEach((field) => {
        field.addEventListener('input', () => field.setCustomValidity(''));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
